import React from 'react';
import ReactDOM from 'react-dom/client';
import './CSS/Index.css';
import './JS/i18n.js'
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './JS/UserContext.js';
import { OptionsProvider } from './JS/OptionsContext.js';

function InitComponent() {

  return (
    <React.StrictMode>
      <BrowserRouter>
        <OptionsProvider>
          <UserProvider>
            <App />
          </UserProvider>
        </OptionsProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <InitComponent />
);